import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _cffe3db6 = () => interopDefault(import('~/pages/_.vue' /* webpackChunkName: "" */))
const _fe9de024 = () => interopDefault(import('../../../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/community-support",
    component: _cffe3db6,
    name: "community-support"
  }, {
    path: "/contact-us",
    component: _cffe3db6,
    name: "contact-us"
  }, {
    path: "/copyright",
    component: _cffe3db6,
    name: "copyright"
  }, {
    path: "/therawealth-product-solutions",
    component: _cffe3db6,
    name: "therawealth-product-solutions"
  }, {
    path: "/about/about-eagle-strategies",
    component: _cffe3db6,
    name: "about-eagle-strategies"
  }, {
    path: "/about/faqs",
    component: _cffe3db6,
    name: "faqs"
  }, {
    path: "/about/my-background",
    component: _cffe3db6,
    name: "my-background"
  }, {
    path: "/client-access/679de457-25be-4055-b7c0-1ae923b38d66",
    component: _cffe3db6,
    name: "679de457-25be-4055-b7c0-1ae923b38d66"
  }, {
    path: "/client-access/7e2c5cb8-fddb-4687-b379-4e002244923b",
    component: _cffe3db6,
    name: "7e2c5cb8-fddb-4687-b379-4e002244923b"
  }, {
    path: "/client-access/8a9b787b-eacc-43c1-9785-c6f03fffc598",
    component: _cffe3db6,
    name: "8a9b787b-eacc-43c1-9785-c6f03fffc598"
  }, {
    path: "/client-access/ac6e55ce-5b5d-41fe-8c18-b23b2d13b1f5",
    component: _cffe3db6,
    name: "ac6e55ce-5b5d-41fe-8c18-b23b2d13b1f5"
  }, {
    path: "/therawealth-planning-services/comprehensive-financial-health-analysis",
    component: _cffe3db6,
    name: "comprehensive-financial-health-analysis"
  }, {
    path: "/therawealth-planning-services/debt-management-and-wealth-building",
    component: _cffe3db6,
    name: "debt-management-and-wealth-building"
  }, {
    path: "/therawealth-planning-services/employee-benefit-plans",
    component: _cffe3db6,
    name: "employee-benefit-plans"
  }, {
    path: "/therawealth-planning-services/income-protection-plans",
    component: _cffe3db6,
    name: "income-protection-plans"
  }, {
    path: "/therawealth-planning-services/investment-plans",
    component: _cffe3db6,
    name: "investment-plans"
  }, {
    path: "/therawealth-planning-services/retirement-plans",
    component: _cffe3db6,
    name: "retirement-plans"
  }, {
    path: "/",
    component: _cffe3db6,
    name: "homepage"
  }, {
    path: "/*",
    component: _fe9de024,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
